/* RESPONSIBLE TEAM: team-actions */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/require-snake-case-analytics */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default Route.extend({
  iamService: service(),
  intercomEventService: service(),
  transitionQueryParams: null,

  async beforeModel(transition) {
    this.transitionQueryParams = transition.to.queryParams;
    await this.iamService.boot(); // need to display the launcher to fire analytics events but do not want it visible on this page.
    window.Intercom('update', { hide_default_launcher: true });
  },

  actions: {
    didTransition() {
      let referal = document.referrer;
      this.intercomEventService.trackAnalyticsEvent({
        action: 'visited',
        section: 'preview',
        object: 'canvas-kit-builder',
        queryParams: this.transitionQueryParams,
        in_snippet: false,
        referal,
      });
    },
  },
});
